import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { randomUid } from "../utils/utils";

import info_icon from '../assets/images/info.svg'

export const InfoTooltip = ({ id=randomUid(), content, className }) => (
    <OverlayTrigger overlay={<Tooltip className='custom-tooltip' id={id}>{content}</Tooltip>}>
        <img src={info_icon} alt='' className={className} />
    </OverlayTrigger>
);